import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_E_INVOICE_PAYMENT_MEANS_CODE, GET_E_INVOICE_PAYMENT_MEANS_CODE, GET_E_INVOICE_PAYMENT_MEANS_CODES, SAVE_E_INVOICE_PAYMENT_MEANS_CODE } from "../../../data/definitions/e-invoice-payment-means-code.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { DeleteEInvoicePaymentMeansCodeMutation, DeleteEInvoicePaymentMeansCodeMutationVariables, DeletionResponse, EInvoicePaymentMeansCode, EInvoicePaymentMeansCodeInput, GetEInvoicePaymentMeansCodeQuery, GetEInvoicePaymentMeansCodeQueryVariables, GetEInvoicePaymentMeansCodesQuery, GetEInvoicePaymentMeansCodesQueryVariables, SaveEInvoicePaymentMeansCodeMutation, SaveEInvoicePaymentMeansCodeMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class EInvoicePaymentMeansCodeService extends BaseListService<EInvoicePaymentMeansCode> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_E_INVOICE_PAYMENT_MEANS_CODES;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetEInvoicePaymentMeansCodesQuery, GetEInvoicePaymentMeansCodesQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetEInvoicePaymentMeansCodeQuery, GetEInvoicePaymentMeansCodeQueryVariables>(
      GET_E_INVOICE_PAYMENT_MEANS_CODE, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getEInvoicePaymentMeansCode);
  }

  async getItemData(id: string): Promise<EInvoicePaymentMeansCode> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getEInvoicePaymentMeansCode as EInvoicePaymentMeansCode;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {

    let res = await lastValueFrom(this.baseDataService.mutate<DeleteEInvoicePaymentMeansCodeMutation, DeleteEInvoicePaymentMeansCodeMutationVariables>(
      DELETE_E_INVOICE_PAYMENT_MEANS_CODE, {
      id: id
    }));

    return res.deleteEInvoicePaymentMeansCode
  }

  async saveItem(documentProject: EInvoicePaymentMeansCode | EInvoicePaymentMeansCodeInput) {

    let validated = await this.systemService.validateObject<EInvoicePaymentMeansCodeInput>(documentProject, "EInvoicePaymentMeansCodeInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveEInvoicePaymentMeansCodeMutation, SaveEInvoicePaymentMeansCodeMutationVariables>(
      SAVE_E_INVOICE_PAYMENT_MEANS_CODE, {
      input: validated
    }));

    return saved.saveEInvoicePaymentMeansCode as EInvoicePaymentMeansCode;
  }
  //#endregion

}
